import './styles.scss';
import React from "react";

/* types, constants, utils */
import * as Constants from "../../../../../../constants";

/* Bootstrap */
import {Pagination} from "react-bootstrap";

interface IProps {
  mode: string;
  handlePrevious():void;
  handleNext():void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
}

const BateBrowsePaging = (props: IProps):JSX.Element => {
  const {
    mode,
    handlePrevious,
    handleNext,
    prevDisabled,
    nextDisabled
  } = props;

  return <div className={"list-paging w-100 d-inline-flex justify-content-center mt-1 mb-2"}>
    <Pagination size="sm" className={"m-0"}>

    {/* Previous */}
    {(mode === Constants.PREVIOUS) &&
      <Pagination.Item
        disabled={prevDisabled}
        onClick={()=>handlePrevious()}
      >
        <div className={'arrow-container d-inline-block p-0 ms-2 me-3 ms-lg-1 '}>
          <div className={'arrow-up small' + (prevDisabled ? ' disabled':'')}/>
        </div>
        <span>{`Previous ${Constants.VW_NUM_ROWS} Records`}</span>
      </Pagination.Item>}

      {/* Next */}
      {(mode === Constants.NEXT) &&
        <Pagination.Item
          className={'me-1'}
          onClick={()=>handleNext()}
          disabled={nextDisabled}
        >
          <div className={'arrow-container d-inline-block p-0 ms-2 me-3 ms-lg-1'}>
            <div className={'arrow-down small' + (nextDisabled ? ' disabled':'')}/>
          </div>
          <span>{`Next ${Constants.VW_NUM_ROWS} Records`}</span>
        </Pagination.Item>}
    </Pagination>

  </div>
}
export default BateBrowsePaging;
